import React from 'react';
import TOCompleteLoginView from "../Views/TO/Code/CompleteLoginView"
import MfaEmailPage from '../Login/MfaEmailPage';
import MfaTrustPage from '../Login/MfaTrustPage';
import MfaSelectPage from '../Login/MfaSelectPage';

class CompleteLogin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: null,
            payload: null,
            showForm: this.props.signInType,
            step: "OTP",
            email: "",
            phone: "",
            acr_values: null
        };
        this.displayForm = this.displayForm.bind(this);
        this.savePayload = this.savePayload.bind(this);
        this.saveStep = this.saveStep.bind(this);
        this.saveEmail = this.saveEmail.bind(this);
        this.savePhone = this.savePhone.bind(this);
    }

    componentDidMount() {
        const username = sessionStorage.getItem("AP_SSID") || null;
        const acr_values = sessionStorage.getItem("acr_values") || null;
        const payloadStr = sessionStorage.getItem("AP_PAYLOAD");
        let payload = null;
        if (payloadStr) {
            try {
                payload = JSON.parse(payloadStr);
            } catch (error) {
                console.error("Invalid payload format", error);
            }
        }
        this.setState({ username, payload, acr_values });
        sessionStorage.removeItem("AP_PAYLOAD");
        sessionStorage.removeItem("acr_values");
    }

    savePayload(value) {
        this.setState({ payload: value });
    }

    displayForm(value) {
        this.setState({ showForm: value });
    }

    saveStep(value) {
        this.setState({ step: value });
    }

    saveEmail(value) {
        this.setState({ email: value });
    }

    savePhone(value) {
        this.setState({ phone: value });
    }

    render() {
        if (this.state.step === "SELECT") {
            return (
                <MfaSelectPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} username={this.state.email} phoneNumber={this.state.phone} />
            )
        } else if (this.state.step === "EMAIL_CODE") {
            return (
                <MfaEmailPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} email={this.state.email} />
            )
        } else if (this.state.step === "TRUST") {
            return (
                <MfaTrustPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} />
            )
        } else {
            return (
                <TOCompleteLoginView
                    style={sessionStorage.AP_STYLE}
                    step={this.state.step}
                    username={this.state.username}
                    payload={this.state.payload}
                    showForm={this.state.showForm}
                    signInType={this.props.signInType}
                    savePayload={this.savePayload}
                    savePhone={this.savePhone}
                    saveEmail={this.saveEmail}
                    saveStep={this.saveStep}
                    displayForm={this.displayForm}
                    acr_values={this.state.acr_values}
                />
            )
        }
    }
}

export default CompleteLogin;